export const ResponseStatus = {
  OK: 'OK',
  NG: 'NG',
}
